import React from 'react';
import {
  AuditReviewSection,
  SectionHeading,
  AuditReviewRows,
  AuditReviewRow,
  AuditNumber,
} from './Review.styles.jsx';

const Review = () => {
  return (
    <AuditReviewSection>
      <SectionHeading>
        <p className="eyebrowHeader">What an Audit Can Help Review</p>

        <h2>Look at the Bigger Picture of Workplace Safety</h2>

        <p>
          A safety audit can help your organization step outside the day-to-day
          routine and look at how its safety program is working as a whole.
        </p>
      </SectionHeading>

      <AuditReviewRows>
        <AuditReviewRow>
          <AuditNumber>01</AuditNumber>

          <div>
            <h3>Policies and Procedures</h3>

            <p>
              Review the safety policies and procedures your organization uses
              to guide employees and workplace activities.
            </p>
          </div>
        </AuditReviewRow>

        <AuditReviewRow>
          <AuditNumber>02</AuditNumber>

          <div>
            <h3>Training and Documentation</h3>

            <p>
              Look at how training, records, manuals, and other safety
              documentation are being managed.
            </p>
          </div>
        </AuditReviewRow>

        <AuditReviewRow>
          <AuditNumber>03</AuditNumber>

          <div>
            <h3>Workplace Practices</h3>

            <p>
              Review how safety expectations and procedures are reflected in
              day-to-day operations.
            </p>
          </div>
        </AuditReviewRow>

        <AuditReviewRow>
          <AuditNumber>04</AuditNumber>

          <div>
            <h3>Areas for Improvement</h3>

            <p>
              Identify opportunities to strengthen systems, documentation, and
              workplace safety practices.
            </p>
          </div>
        </AuditReviewRow>
      </AuditReviewRows>
    </AuditReviewSection>
  );
};

export default Review;
